import { Component,  OnDestroy, Input, OnInit} from '@angular/core';
import {StreamsService}  from "../../../services/streams.service";
import {StreamProject, RestreamItem} from "../../../interfaces";
import { NbGlobalPosition, NbToastrService } from '@nebular/theme';

 
@Component({
  selector: 'app-stream-settings-restreams',
  templateUrl: './stream-settings-restreams.component.html',
  styleUrls: ['./stream-settings-restreams.component.scss'],
})
export class StreamSettingsRestreamsComponent implements OnInit, OnDestroy{


   
  @Input() stream: StreamProject;
  @Input() onRestreamSaved: any;

  restreams: RestreamItem[]  = []
  loading: boolean = false
  save$: any = null
  
  constructor(
    public streamsService: StreamsService,
    private toastrService: NbToastrService
  ){

  } 
 
  ngOnInit() {  
    this.loadData(<RestreamItem[]>this.stream.restreams.map(r => ({...r})))
  }

  loadData(restreams : RestreamItem[]){
    this.restreams = restreams
    for (let i = this.stream.restreams.length; i< 20; i++){
      this.restreams.push(<RestreamItem>{  url: '',  key: '',   active: false,   login: '',   password: '' })
     }
  }

 
/*
  getTemplate(){
    let arr:  RestreamItem[]  = []
    for (let i of Array(6).fill(' ')){
      arr.push({  url: '',  key: '',   active: false,   login: '',   password: '' })
    }
 
    return arr
  }


    isFullEmpty(restreams){

    let empty = true

    for (let restr of restreams ){
        if(  restr.url !== '' ||  restr.key !== '' ||  restr.login !== '' ||  restr.password !== ''  ){
          empty = false
          break;
        }
    }

    return empty
  }

  */

  isUrlValid(userInput) {
     var res = userInput.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    if(res == null)
        return false;
    else
        return true;
  }

  validate(restreams){

    let valid = true

    for (let restr of restreams ){

      delete restr.errorUrl
      delete restr.errorKey
      delete restr.errorLogin
      delete restr.errorPassword

      restr.url = restr.url.trim()
      restr.key = restr.key.trim()
      restr.login = restr.login.trim()
      restr.password = restr.password.trim()

      

      let validateKey = false
      if(restr.url !== '' ){
        if(!this.isUrlValid(restr.url)){
          valid = false
          restr.errorUrl = 'Неправильний URL'
        }else{
          validateKey = true
        }
      }

      if(validateKey){
        if(restr.key === ''){
          valid = false
          restr.errorKey = 'Введіть RTMP ключ'
        }
      }

      if(restr.login !== ''  || restr.password !== '' ){
        if(restr.login === ''){
          valid = false
          restr.errorLogin = 'Введіть логін або видаліть пароль'

        }else  if(restr.password === ''){
          valid = false
          restr.errorPassword = 'Введіть пароль або видаліть логін'
        }
      }

    }


    return valid
  }



  getDataToSave(restreams){
    let arr:  RestreamItem[]  = []

    for (let restr of restreams ){
        if(  restr.url !== '' ||  restr.key !== '' ||  restr.login !== '' ||  restr.password !== ''  ){

	  if(!restr.id){
		restr.id = Date.now()+Math.random( )+''

	  }  
          arr.push({...restr})
        }
    }

    return arr
  }

  save(){
    if(!this.validate(this.restreams)){
      return
    }

    this.loading = true

    this.save$ = this.streamsService.updateRestreams(this.stream._id, this.getDataToSave(this.restreams) )
      .subscribe(
          (stream:StreamProject)=>{
            this.stream.restreams = stream.restreams
               this.loadData((<RestreamItem[]>stream.restreams.map(r => ({...r})))) //stream.restreams.length ? stream.restreams.map(r => ({...r})) : this.getTemplate()
             
              this.onRestreamSaved(stream.restreams)
               this.toastrService.show('','Ретрансляції збережено',{
              status: 'success',
              position: <NbGlobalPosition>'bottom-right'
            })
        }, (error)=>{

            this.toastrService.show('','Сталася помилка збереження',{
              status: 'danger',
              position: <NbGlobalPosition>'bottom-right'
            })
        }, ()=>{
            this.loading = false
        }
      )



  }

  
   ngOnDestroy() { 
      if(this.save$){
        this.save$.unsubscribe()
        this.save$ = null
      }
   }
 
   
  
}
